<template>
  <div class="p-postEditro__itemWrapper">
    <div v-show="editingItemIndex !== index" @click="editItem">
      <TableItemPreview :item="item" />
    </div>
    <item-form
      v-if="editingItemIndex === index"
      :item="item"
      @cancel="resetNum()"
    >
      <div v-if="!tableCreated && !item.isSaved">
        <v-row>
          <v-col>
            <v-col class="d-flex" style="justify-content: space-between;align-items: center;">
              <h3>表タイトル</h3>
              <v-btn color="primary" tile small @click="switchItemToTable">
                新・表アイテムに変更
              </v-btn>
            </v-col>
            <v-text-field
              v-model="tableTitle"
              label="表タイトルを入力してください (任意)"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <h3>行数</h3>
            <v-text-field
              v-model.number="rowNum"
              type="number"
              label="行数を入力してください"
              :rules="numberRule"
              autofocus
            />
          </v-col>
          <v-col>
            <h3>列数</h3>
            <v-text-field
              v-model.number="colNum"
              type="number"
              label="列数を入力してください"
              :rules="numberRule"
            />
          </v-col>
        </v-row>
        <v-btn tile outlined small color="primary" @click="createTable">
          表を作成
        </v-btn>
      </div>

      <div v-if="item.isSaved || tableCreated">
        <v-textarea
          :value="editingItemable.tableTitle"
          label="表タイトル"
          rows="1"
          autofocus
          @input="(value) => updateEditingItemable(value, 'tableTitle')"
        />
        <div class="mb-1">
          <v-btn tile outlined small color="primary" @click="addUpRow">
            上に行を追加
          </v-btn>
          <v-btn tile outlined small color="primary" @click="addUnderRow">
            下に行を追加
          </v-btn>
          <v-btn tile outlined small color="primary" @click="addLeftCol">
            左に列を追加
          </v-btn>
          <v-btn tile outlined small color="primary" @click="addRightCol">
            右に列を追加
          </v-btn>
          <v-btn color="primary" tile small @click="switchItemToTable">
            新・表アイテムに変更
          </v-btn>
        </div>
        <div class="mb-1">
          <v-btn
            tile
            outlined
            small
            color="success"
            @click="alignColumn('left')"
          >
            <v-icon> mdi-format-align-left </v-icon>
          </v-btn>
          <v-btn
            tile
            outlined
            small
            color="success"
            @click="alignColumn('center')"
          >
            <v-icon> mdi-format-align-center </v-icon>
          </v-btn>
          <v-btn
            tile
            outlined
            small
            color="success"
            @click="alignColumn('right')"
          >
            <v-icon> mdi-format-align-right </v-icon>
          </v-btn>
          <v-btn tile outlined small color="secondary" @click="rowHeaderChange">
            <img :src="iconSrc()" width="20" height="20" />
          </v-btn>
          <v-btn tile outlined small color="secondary" @click="colHeaderChange">
            <v-icon> mdi-dock-left </v-icon>
          </v-btn>
        </div>
        <div>
          <v-btn tile outlined small color="error" @click="deleteRow">
            行を削除
          </v-btn>
          <v-btn tile outlined small color="error" @click="deleteCol">
            列を削除
          </v-btn>
        </div>
        <table class="table mt-3">
          <tr
            v-for="(row, rowIndex) in editingItemable.tableContent"
            :key="rowIndex"
          >
            <td
              v-for="(col, colIndex) in row"
              :key="colIndex"
              class="table-cell"
              :style="backgroundStyle(rowIndex, colIndex)"
              @click="selectCell(rowIndex, colIndex)"
            >
              <textarea
                class="table-textarea"
                :value="
                  editingItemable.tableContent[rowIndex.toString()][colIndex]
                "
                :style="
                  cellStyle(
                    editingItemable.tableContent[rowIndex.toString()],
                    colIndex
                  )
                "
                @input="
                  updateEditingItemableNested(
                    $event.target.value,
                    rowIndex,
                    colIndex
                  )
                "
              >
              </textarea>
            </td>
          </tr>
        </table>
      </div>
    </item-form>
  </div>
</template>

<script>
import itemUtilsMixin from '@/mixins/item_utils'
import Icon from '/static/service/table_head_dock.jpeg'
import TableItemPreview from './previews/TableItemPreview'

export default {
  components: { TableItemPreview, Icon },
  mixins: [itemUtilsMixin],
  data: function () {
    return {
      tableCreated: false,
      tableTitle: '',
      rowNum: 2,
      colNum: 2,
      selectRow: null,
      selectCol: null,
      numberRule: [
        (val) =>
          (!isNaN(parseFloat(val)) && val > 0) || '1以上の数字を入力して下さい'
      ]
    }
  },
  computed: {
    tableContent: function () {
      return this.item.itemableAttributes.tableContent
    }
  },
  created: function () {
    if (this.item.isSaved) {
      this.tableTitle = this.item.itemableAttributes.tableTitle
      this.rowNum = Object.keys(
        this.item.itemableAttributes.tableContent
      ).length
      this.colNum = this.item.itemableAttributes.tableContent[0].length
    }
  },
  methods: {
    switchItemToTable () {
      if (confirm('新・表アイテムに変更すると既存のデータ消えます。本当に変更しますか？')) {
        this.switchItem('html_table', this.index)
      }
    },
    resetNum: function () {
      if (!Object.keys(this.item.itemableAttributes.tableContent).length) {
        this.rowNum = 2
        this.colNum = 2
      } else {
        this.rowNum = Object.keys(
          this.item.itemableAttributes.tableContent
        ).length
        this.colNum = this.item.itemableAttributes.tableContent[0].length
      }
    },
    createTable: function () {
      if (this.rowNum < 1 || this.colNum < 1) {
        const payload = {
          status: 400,
          message: '1行1列以上を指定して下さい'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
        return false
      }

      let tableHash = {}
      for (let r = 0; r < this.rowNum; r++) {
        let colArray = new Array(this.colNum).fill('')
        tableHash[r.toString()] = colArray
      }

      this.updateEditingItemable(tableHash, 'tableContent')
      this.updateEditingItemable(this.tableTitle, 'tableTitle')
      this.tableCreated = true
    },
    updateEditingItemableNested: function (val, rowIndex, colIndex) {
      this.$store.state.PostEditor.editingItemable.tableContent[rowIndex][colIndex] = val
      this.updateEditingItemable(
        this.$store.state.PostEditor.editingItemable.tableContent,
        'tableContent'
      )
    },
    deepClone: function (obj) {
      let newObj = Object.assign({}, obj)

      Object.keys(newObj).forEach((k) => (newObj[k] = [...newObj[k]]))
      return newObj
    },
    addUpRow: function () {
      let tmp = this.$store.state.PostEditor.editingItemable.tableContent
      let tableHash = this.deepClone(tmp)
      let addArray = new Array(this.colNum).fill('')
      for (let r = this.rowNum; r > Number(this.selectRow); r--) {
        tableHash[r] = tableHash[r - 1]
        delete tableHash[r - 1]
      }
      tableHash[Number(this.selectRow)] = addArray
      this.updateEditingItemable(tableHash, 'tableContent')
      this.rowNum += 1
    },
    addUnderRow: function () {
      let tmp = this.$store.state.PostEditor.editingItemable.tableContent
      let tableHash = this.deepClone(tmp)
      let addArray = new Array(this.colNum).fill('')
      for (let r = this.rowNum; r > Number(this.selectRow) + 1; r--) {
        tableHash[r] = tableHash[r - 1]
        delete tableHash[r - 1]
      }
      tableHash[Number(this.selectRow) + 1] = addArray
      this.updateEditingItemable(tableHash, 'tableContent')
      this.rowNum += 1
    },
    addLeftCol: function () {
      let tmp = this.$store.state.PostEditor.editingItemable.tableContent
      let tableHash = this.deepClone(tmp)
      for (let r = 0; r < this.rowNum; r++) {
        tableHash[r.toString()].splice(this.selectCol, 0, '')
      }
      this.updateEditingItemable(tableHash, 'tableContent')
      this.colNum += 1
    },
    addRightCol: function () {
      let tmp = this.$store.state.PostEditor.editingItemable.tableContent
      let tableHash = this.deepClone(tmp)
      for (let r = 0; r < this.rowNum; r++) {
        tableHash[r.toString()].splice(this.selectCol + 1, 0, '')
      }
      this.updateEditingItemable(tableHash, 'tableContent')
      this.colNum += 1
    },
    deleteRow: function () {
      if (this.rowNum === 1) {
        const payload = {
          status: 400,
          message: '表は1行以上必要です'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
        return false
      }

      let tmp = this.$store.state.PostEditor.editingItemable.tableContent
      let tableHash = this.deepClone(tmp)
      if (this.selectRow == Object.keys(tableHash).length - 1) {
        delete tableHash[this.selectRow.toString()]
      } else {
        for (
          let r = Number(this.selectRow);
          r < Object.keys(tableHash).length;
          r++
        ) {
          tableHash[r.toString()] = tableHash[(r + 1).toString()]
        }
        delete tableHash[Object.keys(tableHash).length - 1]
      }
      this.updateEditingItemable(tableHash, 'tableContent')
      this.rowNum -= 1
    },
    deleteCol: function () {
      if (this.colNum === 1) {
        const payload = {
          status: 400,
          message: '表は1列以上必要です'
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
        return false
      }

      let tmp = this.$store.state.PostEditor.editingItemable.tableContent
      let tableHash = this.deepClone(tmp)
      for (let r = 0; r < this.rowNum; r++) {
        tableHash[r].splice(this.selectCol, 1)
      }
      this.updateEditingItemable(tableHash, 'tableContent')
      this.colNum -= 1
    },
    alignColumn: function (direction) {
      let tmp = this.$store.state.PostEditor.editingItemable.tableStyle
      let tableHash = Object.assign({}, tmp)
      if (['left', 'center', 'right'].includes(direction)) {
        tableHash[this.selectCol] = direction
      }
      this.updateEditingItemable(tableHash, 'tableStyle')
    },
    rowHeaderChange: function () {
      let tmp = this.$store.state.PostEditor.editingItemable.headerStyle
      let tableHash = Object.assign({}, tmp)
      if (tableHash['row'] == null || tableHash['row'] === 'normal') {
        tableHash['row'] = 'stripe'
      } else {
        tableHash['row'] = 'normal'
      }
      this.updateEditingItemable(tableHash, 'headerStyle')
    },
    colHeaderChange: function () {
      let tmp = this.$store.state.PostEditor.editingItemable.headerStyle
      let tableHash = Object.assign({}, tmp)
      if (tableHash['col'] == null || tableHash['col'] === 'normal') {
        tableHash['col'] = 'stripe'
      } else {
        tableHash['col'] = 'normal'
      }
      this.updateEditingItemable(tableHash, 'headerStyle')
    },
    cellStyle: function (row, colIndex) {
      let lines = 0
      let style
      // 行高さ設定
      for (let c = 0; c < row.length; c++) {
        let tmplines = row[c].match(/\n/g) ? row[c].match(/\n/g).length : 0
        if (tmplines > lines) {
          lines = tmplines
        }
      }
      // 文字位置設定
      if (this.$store.state.PostEditor.editingItemable.tableStyle) {
        let tmpobj = this.$store.state.PostEditor.editingItemable.tableStyle
        Object.keys(tmpobj).some(function (key) {
          if (colIndex === Number(key)) {
            style = 'text-align: ' + tmpobj[key] + ';'
            return true
          }
        })
      }
      return 'height: ' + (lines + 1) * 2 + 'rem;' + style
    },
    selectCell: function (rowIndex, colIndex) {
      this.$data.selectRow = rowIndex
      this.$data.selectCol = colIndex
    },
    backgroundStyle: function (rowIndex, colIndex) {
      let style = ''
      if (this.$store.state.PostEditor.editingItemable.headerStyle) {
        let obj = this.$store.state.PostEditor.editingItemable.headerStyle
        if (obj['row'] && Number(rowIndex) === 0) {
          if (obj['row'] === 'stripe') {
            style = 'background-color: #f7f7f7;'
          } else {
            style = 'background-color: white;'
          }
        }
        if (obj['col'] && Number(colIndex) === 0) {
          if (obj['col'] === 'stripe') {
            style = 'background-color: #f7f7f7;'
          }
        }
      }
      return style
    },
    iconSrc () {
      return Icon
    }
  }
}
</script>

<style scoped>
.table {
  width: 100%;
  table-layout: fixed;
  border: 1px double #b4b4b4;
}
.table-cell {
  margin: 0px;
  border: 1px solid #e8e8e8;
}
.table-textarea {
  vertical-align: middle;
  border: none;
  padding: 0.2em 0.5em;
  resize: none;
  overflow: hidden;
  width: 100%;
}
.table-textarea:focus {
  outline: 2px solid #039be5;
}
</style>
